export function ofCode(code: string) {
    return (f) => f.fields && f.code === code;
}

export function ofMain() {
    return ofCode('main');
}